import React from 'react'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import { setDate, setView } from '../../../redux/actions/setFilters'
import useKeyPressEvent from '../../../utilities/events/useKeyPressEvent'
import labels from '../../../configuration/labels'
import views from '../../../configuration/views'

import '../../../styles/scss/components/calendar/popover.scss'

const CalendarDateCellPopover = ({ day, selectedDate, handleEventsPopup, renderPopoverEvents }) => {
  const dispatch = useDispatch()

  // onClick of CTA close unset selected date cell & popup,
  // set active date and redirect user to the grid cards view
  const handleViewDay = () => {
    dispatch(setDate(moment(day)))
    dispatch(setView(views.daily))
  }

  // onKeyDown for esc unset selected date cell & popup
  useKeyPressEvent('Escape', () => {
    handleEventsPopup('')
  })

  let titleDateFormat = 'dddd, MMMM Do'

  if (process.env.REACT_APP_FORMAT_CALENDER_POPOVER_TITLE_DATE) {
    titleDateFormat = process.env.REACT_APP_FORMAT_CALENDER_POPOVER_TITLE_DATE
  }

  return (
    <div className="flow-events-popover">
      <div className="flow-events-popover__header">
        <h6>
          {moment(day).format(titleDateFormat)}

          <button
            className="flow-events-popover__header-close"
            onClick={moment(day).isSame(selectedDate, 'day') ? () => handleEventsPopup('') : null}
          >
            {labels.closeCta}
          </button>
        </h6>
      </div>

      {renderPopoverEvents && (
        <div className="flow-events-popover__content">
          {renderPopoverEvents}

          <button className="flow-events-popover__event-toggle" onClick={() => handleViewDay()}>
            {labels.viewDayCta}
          </button>
        </div>
      )}
    </div>
  )
}

export default CalendarDateCellPopover
